import type { GetFxMarkups200DataItem } from 'api/customerApi';

export function adaptMarkupsToBeBidirectional(
  data: GetFxMarkups200DataItem[]
): GetFxMarkups200DataItem[] {
  const uniquePairs = new Set<string>();

  // Collect unique pairs
  const result: GetFxMarkups200DataItem[] = [];
  data.forEach(({ id, buy_currency_iso, pay_currency_iso }) => {
    if (!id || !buy_currency_iso || !pay_currency_iso) {
      return;
    }
    // Sort the currencies to ensure the same pair order
    const normalizedPair = [buy_currency_iso, pay_currency_iso].sort();
    const pairKey = `${normalizedPair[0]}-${normalizedPair[1]}`; // Create a unique key

    if (!uniquePairs.has(pairKey)) {
      uniquePairs.add(pairKey);

      // Add both the original and reverse only once
      result.push({
        id: id,
        buy_currency_iso,
        pay_currency_iso
      });
      result.push({
        id: id,
        buy_currency_iso: pay_currency_iso,
        pay_currency_iso: buy_currency_iso
      });
    }
  });
  return result;
}
